import Icon from "../Icon";
import Button from ".";
import useS3Download from "@/app/hooks/useS3Download";

function DownloadButton({
	variant,
	link = false,
	outline = true,
	fileId,
	folder,
	name,
	type,
	icon = "file-download",
	size = "sm",
	children = "Download",
}) {
	const s3Download = useS3Download();
	if (fileId == null) {
		console.error("DownloadButton: missing fileId");
		return null;
	}
	const handleDownload = () => {
		s3Download(folder, fileId, name, type);
	};
	return (
		<Button
			variant={variant}
			link={link}
			outline={outline}
			size={size}
			onClick={handleDownload}
		>
			{children}
			<Icon name={icon} />
		</Button>
	);
}

export default DownloadButton;
